module.exports = __webpack_public_path__ + "img/1531691048.f1a28c65.jpg";